// hooks/useProfileCheck.js
import { useMemo } from "react";

const PROFILE_CHECKS = [
  {
    key:          "phone",
    test:         (u) => !!u?.phone?.trim(),
    severity:     "error",
    dismissible:  false,   // required for all transactions — never skippable
  },
  {
    key:          "transactionPin",
    test:         (u) => !!u?.hasTransactionPin,
    severity:     "error",
    dismissible:  false,   // required to confirm any payment — never skippable
  },
  {
    key:          "name",
    test:         (u) => !!(u?.firstName?.trim() && u?.lastName?.trim()),
    severity:     "warning",
    dismissible:  true,
  },
  {
    key:          "profileImage",
    test:         (u) => !!u?.profileImage,
    severity:     "info",
    dismissible:  true,
  },
];

const KYC_SEVERITY = {
  not_started:    { severity: "warning", dismissible: true  },
  rejected:       { severity: "error",   dismissible: false },
  info_requested: { severity: "warning", dismissible: true  },
  submitted:      null,
  under_review:   null,
  approved:       null,
};

export function useProfileCheck(user) {
  return useMemo(() => {
    if (!user) return { prompts: [], hasWarning: false, hasError: false, blockingPrompt: null };

    const prompts = [];

    PROFILE_CHECKS.forEach(({ key, test, severity, dismissible }) => {
      if (!test(user)) prompts.push({ type: "profile", key, severity, dismissible });
    });

    const kycStatus = user.kycStatus || "not_started";
    const kyc       = KYC_SEVERITY[kycStatus];
    if (kyc) {
      prompts.push({ type: "kyc", key: "kyc", kycStatus, severity: kyc.severity, dismissible: kyc.dismissible });
    }

    const hasWarning     = prompts.some(p => p.severity === "warning");
    const hasError       = prompts.some(p => p.severity === "error");
    // The most critical undismissible prompt — used to block bill payment pages
    const blockingPrompt = prompts.find(p => !p.dismissible) || null;

    return { prompts, hasWarning, hasError, blockingPrompt };
  }, [user]);
}

export default useProfileCheck;
